module.exports = __webpack_public_path__ + "img/logosidebar.55bbc459.png";